<template>
    <div>
        <app-sub-title
            :text="'Formato: ' + formatTitle + ' [' + formatCode + ']'"
        />
        <b-btn
            variant="primary"
            @click="$router.push({ name: 'formatsPage' })"
            title="Volver"
        >
            <i class="fa fa-arrow-left"></i>
        </b-btn>
        <b-btn variant="primary" @click="onDownload" title="Descargar">
            <i class="fa fa-download"></i>
        </b-btn>
        <b-btn variant="primary" @click="print" title="Descargar">
            <i class="fa fa-print"></i>
        </b-btn>
        <app-data-table :items="data" :fields="fields">
            <template slot="signature_url" slot-scope="{ item }">
                <b-img
                    :src="item.signature_url"
                    style="max-height: 25px;"
                ></b-img>
            </template>
            <template slot="actions" slot-scope="{ item }">
                <b-btn variant="primary" size="sm" @click="onView(item)">
                    <i class="fa fa-search"></i>
                </b-btn>
            </template>
        </app-data-table>
    </div>
</template>
<script>
export default {
    data() {
        return {
            data: [],
            fields: [],
            datax: [],
            page: 1,
            itemType: '',
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc',
            },
        }
    },
    props: {
        formatId: {
            type: [Number, String],
            default: 0,
        },
        formatTitle: {
            type: String,
            default: '',
        },
        formatCode: {
            type: String,
            default: '',
        },
    },
    methods: {
        async loadFields() {
            try {
                let tempFields = []
                const { data } = await repo.get(
                    `formats/format/${this.formatId}/load-fields-data`
                )
                tempFields = data

                tempFields.push(
                    { key: 'user_name', label: 'Nombre y Apellido' },
                    { key: 'created_at', label: 'Fecha y hora' },
                    { key: 'signature_url', label: 'Firma' },
                    {
                        key: 'actions',
                        label: 'Acciones',
                    }
                )
                this.fields = tempFields
                // console.log('load fields es')
                // console.log(this.fields)
            } catch (err) {
                this.handleErrors(err)
            }
        },
        async loadData() {
            try {
                const { data } = await repo.get(
                    `formats/format/${this.formatId}/load-response-data-name`
                )
                let tempData = []
                // console.log(data)

                data.map(item => {
                    let response = JSON.parse(item.details)
                    let dataJson = ''
                    // console.log(response.response)
                    response.response.map(itemIn => {
                        dataJson +=
                            '"' +
                            itemIn.format_fields_id +
                            '": "' +
                            (itemIn.value ?? '') +
                            '", '
                    })

                    dataJson +=
                        '"user_name": "' +
                        item.user_name +
                        '", "signature_url": "' +
                        (!!item.signature_url ? item.signature_url : '') +
                        '", "created_at": "' +
                        item.created_at +
                        '", "id": "' +
                        item.id +
                        '"'
                    tempData.push(JSON.parse('{' + dataJson + '}'))
                    this.data = tempData
                    // console.log('load data es')
                    // console.log(this.data)
                })
            } catch (err) {
                this.handleErrors(err)
            }
        },
        onView(item) {
            console.log('id de respuesta' + item.id)
            console.log('id de formato' + this.formatId)
            return this.$router.push({
                name: 'formatDetail',
                params: {
                    formatId: this.formatId,
                    formatHeaderId: item.id,
                    formatTitle: this.formatTitle,
                    formatCode: this.formatCode,
                },
            })
        },
        onDownload() {
            this.formatId
            console.log(this.formatId)
            window.open(
                `web/v1/formats/format/${this.formatId}/download`,
                '_blank'
            )
        },
        print() {
            window.print()
        },
    },
    created() {
        this.loadFields()
        this.loadData()
    },
}
</script>
